import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';

import { Manifest } from 'services/action';
import {
  Action,
  SectionSummary,
  SectionMap,
  SectionInfo,
  SectionLegs,
} from 'ui/screens/authorized/manifest/component/detail';
import { SectionAdditional } from 'ui/screens/authorized/manifest/component/detail';

const initialState = {
  data: null,
  privilege: null,
  legs: null,
  summary: {
    weight: 0,
    quantity: 0,
  },
};

const ManifestTrucking = ({ id, reloadOrder, setCount }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Manifest.Show']
  );

  const [{ data, privilege }, setState] = React.useState(initialState);

  const $onLoad = async (id) => {
    const req = await Dispatch(Manifest.$show(id));

    if (req?.message === 'success') {
      setState((prevState) => ({
        ...prevState,
        data: req?.data,
      }));
    } else {
    }
  };

  const $handleLegsChange = () => {
    $onLoad(id);
  };

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.manifest',
    });
    setState((prevState) => ({
      ...prevState,
      privilege: x,
    }));
  };

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  React.useEffect(() => {
    $onLoad(id);
  }, [id]);

  React.useEffect(() => {
    if (!data) return;

    let tw = _.reduce(
      data?.jobs,
      function (sum, item) {
        if (item?.delivery_order?.shipment) {
          return sum + item?.delivery_order?.shipment?.total_weight;
        }
        return sum;
      },
      0
    );

    let tq = _.reduce(
      data?.jobs,
      function (sum, item) {
        if (item?.delivery_order?.shipment) {
          return sum + item?.delivery_order?.shipment?.total_quantity;
        }
        return sum;
      },
      0
    );

    setState((prevState) => ({
      ...prevState,
      summary: {
        weight: tw,
        quantity: tq,
      },
    }));

    setCount(data?.legs_count);
  }, [data]);

  return (
    <div>
      <div className="d-flex justify-content-between mb-3">
        <div>
          <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
            Manifest Trucking
          </div>
        </div>
        <Action
          data={data}
          onSubmit={() => $onLoad(id)}
          privilege={privilege?.action === 'manage' || !Session?.privileges}
          orderTrucking
          reloadOrder={reloadOrder}
        />
      </div>

      <SectionMap manifest={data} loading={StateLoading} />
      <div className="">
        <SectionSummary manifest={data} />

        <div className="row">
          <div className="col-md-4">
            <SectionInfo manifest={data} loading={StateLoading} />

            <SectionAdditional
              data={data}
              loading={StateLoading}
              onSubmit={() => $onLoad(id)}
            />
          </div>
          <div className="col-md-8">
            <SectionLegs
              manifest={data}
              onLegChanges={$handleLegsChange}
              loading={StateLoading}
              privilege={!Session?.privileges || privilege?.action === 'manage'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManifestTrucking;
